function createCodexPrismSignatureRuntime(seed) {
  return {
    seed,
    mount() {
      document.documentElement.setAttribute("data-codex-code-runtime", this.seed.signature);
      document.documentElement.setAttribute("data-codex-code-runtime-family", this.seed.family);
      document.documentElement.setAttribute("data-codex-code-runtime-history", "r" + this.seed.historyRevision);
      document.documentElement.style.setProperty("--codex-code-runtime-token", "345");
      document.documentElement.style.setProperty("--codex-code-runtime-family-token", "992");
      document.documentElement.style.setProperty("--codex-code-runtime-history-revision", "4");
      window.__CODEX_THEME_SIGNATURE__ = this.seed;
    },
  };
}

const codexPrismRuntime = createCodexPrismSignatureRuntime({"signature": "uhbjwd-1u", "family": "drpepper", "historyRevision": 4, "styleKind": "prism"});

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => codexPrismRuntime.mount(), { once: true });
} else {
  codexPrismRuntime.mount();
}
